// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__-GYP3"};